import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import SiteContainer from '../../../components/layout/SiteContainer'
import HelmetTitle from '../../../components/layout/HelmetTitle'
import ContainerHeading from '../../../components/layout/ContainerHeading'
import ArrowRightBoldCircle from '../../../components/icons/ArrowRightBoldCircle'
import { H1, GridContainer, GridSection, Column, ListRow, ColumnStyle, ColumnResponsiveInnerContainer, ActionColumnStyleRightAligned, ActionIconContainer, NavBar, NavFwdBackButton } from '../../../components/management/styled-elements'

import { duplicateParentCompanySite, fetchSites, fetchChildCompanySites } from '../../../actions/SiteActions'
import { fetchChildCompanies } from '../../../actions/ChildCompanyActions'
import { fetchTimezones } from '../../../actions/TimezoneActions'
import { fetchDataLoggerDevices, fetchChildCompanyAndUnallocatedDataLoggerDevices } from '../../../actions/DataLoggerDeviceActions'

import SiteDuplicateForm from '../../../components/management/sites/DuplicateForm'

class ManagementSitesDuplicate extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      hasErrors: false,
      siteToDuplicateId: null,
      dataLoggerDeviceId: null,
      targetCompanyId: null,
      newSiteName: null,
      targetSiteId: null,
      timezoneId: null,
    }
  }

  componentDidMount() {
    const { dispatch, apiAuth, sites, childCompanies, dataLoggerDevices, timezones } = this.props
    const { user } = apiAuth
    if (user.company_type==='user') {
      !sites.sites.length && dispatch(fetchSites(user.company_slug))
      !dataLoggerDevices.dataLoggerDevices.length && dispatch(fetchDataLoggerDevices(user.company_slug))
    } else if (['dealer','consultant'].includes(user.company_type)) {
      !sites.sites.length && dispatch(fetchChildCompanySites(user.company_slug))
      dispatch(fetchChildCompanies(user.company_slug))
      dispatch(fetchChildCompanyAndUnallocatedDataLoggerDevices(user.company_slug))
    }
    !timezones.timezones.length && dispatch(fetchTimezones())
  }

  componentDidUpdate(prevProps) {
    const { dispatch, apiAuth, sites } = this.props
  }

  backToSites = () => {
    const prevRoute = '/management/sites'
    if (window.lastLocation && (window.lastLocation.host===window.location.host)) {
      this.props.history.goBack()
    } else {
      this.props.dispatch(push(prevRoute))
    }
  }

  handleAutocompleteChange = name => ({ value }) => {
    this.setState({ [name]: value })
  }

  handleInputChange = event => {
    console.log("XXX event.target",event.target)
    console.log("XXX event.target.name",event.target.name)
    console.log("XXX event.target.value",event.target.value)
    this.setState({ [event.target.name]: event.target.value },(state) => {console.log('XXX handleInputChange',state)})
  }

  configFormSubmitHandler = (siteId,submitParams) => {
    const { dispatch, apiAuth, sites } = this.props
    const { user } = apiAuth
    const site = sites.sites.find(({id}) => id===siteId)
    const { company_slug, slug } = site
    dispatch(duplicateParentCompanySite(company_slug,slug,submitParams))
  }

  validate = (callback) => {
    const errors = {}
    const {
      siteToDuplicateId,
      dataLoggerDeviceId,
      targetCompanyId,
      newSiteName,
      targetSiteId,
      timezoneId,
    } = this.state
    if (!siteToDuplicateId) {
      errors['siteToDuplicateId'] = 'Site To Duplicate is required'
    }
    if (Object.keys(errors).length) {
      this.setState({
        hasErrors: true,
        errors: errors
      })
    } else {
      const siteId = siteToDuplicateId
      const submitParams = this.getSubmitParams()
      callback.call(this,siteId,submitParams)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      hasErrors: false,
      formErrors: null,
      errors: null,
    })
    this.validate.call(this,this.configFormSubmitHandler)
  }

  getSubmitParams = () => {

    const {
      siteToDuplicateId,
      dataLoggerDeviceId,
      targetCompanyId,
      newSiteName,
      targetSiteId,
      timezoneId,
    } = this.state

    const paramsObj = {
      origin_site_id: siteToDuplicateId,
      data_logger_device_id: dataLoggerDeviceId,
      target_company_id: targetCompanyId,
      target_site_id: targetSiteId,
      new_site_name: newSiteName,
      timezone_id: timezoneId,
    }

    return paramsObj

  }


  renderSiteDuplicateContent(state,props) {

    console.log("XXX state",state)

    return <div>
      <NavBar>
        <NavFwdBackButton onClick={this.backToSites.bind(this)}>&#171; Back to Sites Management</NavFwdBackButton>
      </NavBar>
      <GridContainer>
        <ContainerHeading title={`Duplicate a Site`} />
        <GridSection>
          <SiteDuplicateForm
            sites={props.sites}
            dataLoggerDevices={props.dataLoggerDevices}
            childCompanies={props.childCompanies}
            timezones={props.timezones}
            errors={state.errors}
            hasErrors={state.hasErrors}
            handleAutocompleteChange={this.handleAutocompleteChange}
            handleInputChange={this.handleInputChange}
            siteToDuplicateId={state.siteToDuplicateId}
            dataLoggerDeviceId={state.dataLoggerDeviceId}
            targetCompanyId={state.targetCompanyId}
            newSiteName={state.newSiteName}
            targetSiteId={state.targetSiteId}
            timezoneId={state.timezoneId}
            handleSubmit={this.handleSubmit}
          />
        </GridSection>
      </GridContainer>
    </div>
  }

  renderBody = (props,state) => {
    return <div>
      { this.renderSiteDuplicateContent(state,props) }
    </div>
  }

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={'Duplicate a Site'} />
    { this.renderBody(this.props,this.state) }
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    sites: store.sites,
    dataLoggerDevices: store.dataLoggerDevices,
    childCompanies: store.childCompanies,
    timezones: store.timezones,
  }),
)(ManagementSitesDuplicate)



// WEBPACK FOOTER //
// ./src/containers/management/sites/duplicate.js